import Stock from './Stock';

class Booking extends Stock {
    public arrivalDate: Date;
}

export default Booking;